import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './_nath_silva_consultoria.module.scss';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const WHATSAPP_NUMBER = '5511959876108';
const WHATSAPP_MSG =
    'Olá, Nath! Vi a página de consultoria pelo link na bio e quero entender como funciona o acompanhamento e os planos. Podemos conversar?';

const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;

/** Ordem natural 1–10 (evita sort alfabético 1, 10, 2…) */
const GALLERY_ITEMS: { src: string; label: string }[] = [
    { src: require('./src/consultoria/consultoria_1.png'), label: '01' },
    { src: require('./src/consultoria/consultoria_2.png'), label: '02' },
    { src: require('./src/consultoria/consultoria_3.png'), label: '03' },
    { src: require('./src/consultoria/consultoria_4.png'), label: '04' },
    { src: require('./src/consultoria/consultoria_5.png'), label: '05' },
    { src: require('./src/consultoria/consultoria_6.png'), label: '06' },
    { src: require('./src/consultoria/consultoria_7.png'), label: '07' },
];

const _nath_silva_consultoria: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles._nath_silva_consultoria}>
            <div className={styles.page}>
                <div className={styles.header}>
                    <Link
                        to="/_nath_silva"
                        state={{ skipLoader: true }}
                        className={styles.backButton}
                        aria-label="Voltar ao link na bio"
                    >
                        <FaArrowLeft />
                    </Link>
                    <div className={styles.headerText}>
                        <p className={styles.eyebrow}>Nathalia Silva</p>
                        <h1 className={styles.title}>Consultoria online</h1>
                    </div>
                </div>

                <p className={styles.intro}>
                    Abaixo você confere o material completo: como funciona o método, diferenciais do acompanhamento e
                    informações para decidir com segurança.
                </p>

                <div className={styles.grid}>
                    {GALLERY_ITEMS.map((item, index) => (
                        <figure key={item.src} className={styles.card}>
                            <img
                                src={item.src}
                                alt={`Consultoria Personal Nathalia Silva — slide ${item.label}`}
                                className={styles.cardImage}
                                loading={index < 2 ? 'eager' : 'lazy'}
                            />
                            <figcaption className={styles.cardFigcaption}>{item.label}</figcaption>
                        </figure>
                    ))}
                </div>

                <div className={styles.ctaSection} aria-labelledby="cta-consultoria-nath-heading">
                    <h2 id="cta-consultoria-nath-heading" className={styles.ctaHeading}>
                        Você merece se sentir incrível<br />e isso começa agora
                    </h2>
                    <p className={styles.ctaText}>
                        Se você se identificou com o que viu nas imagens, o próximo passo é simples: falar comigo no
                        WhatsApp. Tiramos dúvidas sobre formatos de consultoria, acompanhamento e como começar sem
                        complicação, com a mesma proximidade de quem acompanha alunos todos os dias.
                    </p>
                    <a href={whatsappLink} className={styles.ctaWhatsapp} target="_blank" rel="noopener noreferrer">
                        <WhatsappIcon height="28" color="#ffffff" />
                        <span>Quero saber mais</span>
                    </a>
                </div>

                <p className={styles.footerNote}>
                    Informações comerciais e condições podem ser confirmadas diretamente no atendimento. Resultados
                    dependem de adesão individual ao programa.
                </p>
            </div>
        </div>
    );
};

export default _nath_silva_consultoria;
